export const space2 = 2;
export const space3 = 3;
export const space4 = 5;
export const space5 = 7;
export const space6 = 10;
export const space7 = 15;
export const space8 = 20;
export const space9 = 22;
export const space10 = 30;
export const space11 = 35;
export const space12 = 45;
export const space13 = 50;
export const space14 = 60;
export const space15 = 90;
export const space16 = 120;

export const quarterGutter = space5;
export const halfGutter = space7;
export const gutter = space10;
export const doubleGutter = space14;
export const sesquiGutter = space12;
export const oneAndHalfGutter = space12;
export const tripleGutter = space15;

// replaces cta-icon, back-icon, forward-icon
export const inlineIcon = space4;

// replaces icon offset prop
export const iconOffset = '0.3em';

export const spaceTextLarge = '1.6rem';
export const spaceTextSmall = '0.8rem';

const largeHeading = { top: 0, bottom: spaceTextLarge };
const smallHeading = { top: 0, bottom: spaceTextSmall };

export const typography = {
    h0: largeHeading,
    h1: largeHeading,
    h2: largeHeading,
    h3: largeHeading,
    h4: largeHeading,
    h5: smallHeading,
    h6: smallHeading,
    h7: smallHeading,
    paragraph: spaceTextLarge,
    blockquote: spaceTextLarge,
    hr: spaceTextLarge,
    ul: spaceTextLarge,
    ol: spaceTextLarge,
};

export const layout = {
    sectionTop: doubleGutter,
    sectionBottom: tripleGutter,
    smallSectionTop: oneAndHalfGutter,
    smallSectionBottom: doubleGutter,

    twoColumnLayout: {
        bottomSpacing: {
            all: doubleGutter,
            small: oneAndHalfGutter,
            medium: oneAndHalfGutter,
        },
        bottomDistance: {
            all: oneAndHalfGutter,
            small: gutter,
            medium: gutter,
        },
    },

    contentHeader: {
        topSpacing: {
            base: {
                all: oneAndHalfGutter,
                small: gutter,
                medium: gutter,
            },
            compact: {
                all: space9,
                small: space7,
                medium: space7,
            },
        },
        bottomSpacing: {
            all: oneAndHalfGutter,
            small: gutter,
            medium: gutter,
        },
        backDistance: gutter,
        menuDistance: gutter,
    },

    contentBody: {
        topSpacing: {
            base: {
                all: gutter,
                small: halfGutter,
                medium: halfGutter,
            },
            spacious: {
                all: doubleGutter,
                small: oneAndHalfGutter,
                medium: oneAndHalfGutter,
            },
        },
        bottomSpacing: {
            all: tripleGutter,
            small: doubleGutter,
            medium: doubleGutter,
        },
    },
};

export type Space =
    | 'none'
    | 'space2'
    | 'space3'
    | 'space4'
    | 'space5'
    | 'space6'
    | 'space7'
    | 'space8'
    | 'space9'
    | 'space10'
    | 'space11'
    | 'space12'
    | 'space13'
    | 'space14'
    | 'space15'
    | 'space16'
    | 'quarterGutter'
    | 'halfGutter'
    | 'gutter'
    | 'doubleGutter'
    | 'oneAndHalfGutter'
    | 'tripleGutter'
    | 'textLarge'
    | 'textSmall'
    | 'auto';

// These records should include units as they are used directly in Styled Components CSS
export const sizes: Record<Space, string> = {
    none: '0',
    space2: space2 + 'px',
    space3: space3 + 'px',
    space4: space4 + 'px',
    space5: space5 + 'px',
    space6: space6 + 'px',
    space7: space7 + 'px',
    space8: space8 + 'px',
    space9: space9 + 'px',
    space10: space10 + 'px',
    space11: space11 + 'px',
    space12: space12 + 'px',
    space13: space13 + 'px',
    space14: space14 + 'px',
    space15: space15 + 'px',
    space16: space16 + 'px',
    quarterGutter: quarterGutter + 'px',
    halfGutter: halfGutter + 'px',
    gutter: gutter + 'px',
    doubleGutter: doubleGutter + 'px',
    oneAndHalfGutter: oneAndHalfGutter + 'px',
    tripleGutter: tripleGutter + 'px',
    textLarge: spaceTextLarge,
    textSmall: spaceTextSmall,
    auto: 'auto',
};

export const negativeSizes: Record<Space, string> = {
    none: '0',
    space2: '-' + space2 + 'px',
    space3: '-' + space3 + 'px',
    space4: '-' + space4 + 'px',
    space5: '-' + space5 + 'px',
    space6: '-' + space6 + 'px',
    space7: '-' + space7 + 'px',
    space8: '-' + space8 + 'px',
    space9: '-' + space9 + 'px',
    space10: '-' + space10 + 'px',
    space11: '-' + space11 + 'px',
    space12: '-' + space12 + 'px',
    space13: '-' + space13 + 'px',
    space14: '-' + space14 + 'px',
    space15: '-' + space15 + 'px',
    space16: '-' + space16 + 'px',
    quarterGutter: '-' + quarterGutter + 'px',
    halfGutter: '-' + halfGutter + 'px',
    gutter: '-' + gutter + 'px',
    doubleGutter: '-' + doubleGutter + 'px',
    oneAndHalfGutter: '-' + oneAndHalfGutter + 'px',
    tripleGutter: '-' + tripleGutter + 'px',
    textLarge: '-' + spaceTextLarge,
    textSmall: '-' + spaceTextSmall,
    auto: 'auto',
};
